<txtb-drawer
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [actionContentCollapsed]="actionContentCollapsed"
  (contentCollapse)="contentCollapse($event)"
  [groupInfo]="groupInfo"
  [zoomFeatureAvailable]="true"
  (actionDrawerApiInitialized)="onActionDrawerApiInitialized($event)"
>
  <article main class="document-image">
    <div #wrapper class="image-wrapper">
      <txtb-image-wrapper
        [fixRender]="false"
        [proportionalRender]="false"
        [verticalScroll]="action.meta.verticalScroll"
        [horizontalScroll]="action.meta.horizontalScroll"
        [start]="true"
        *ngFor="
          let resourceId of resources
            | paginate
              : { itemsPerPage: 1, currentPage: activeElementIndex, totalItems: resources.length }
        "
        [attr.sub]="imageSrc$(resourceId, activeElementIndex) | async"
        alt="zasób multipodręcznika"
        [src]="imageSrc[activeElementIndex]"
        [imgSrc]="imageSrc[activeElementIndex]"
        [imagesScalingEnabled]="!!action.meta?.imagesScalingEnabled"
        [percentageScale]="action.meta?.percentageScale || null"
      ></txtb-image-wrapper>
    </div>
  </article>
  <section class="pagination-wrapper" footer *ngIf="pagination">
    <txtb-documents-paginator
      (pageChange)="changeElement($event)"
      class="paginator"
    ></txtb-documents-paginator>
  </section>
</txtb-drawer>
